export default "__VITE_ASSET__BTj5G8jy__"